// extracted by mini-css-extract-plugin
export var sectionTitle = "section-title-module--section-title--12EjZ";
export var gradient = "section-title-module--gradient--2xEau";
export var sectionTitle__en = "section-title-module--section-title__en--2Hk8T";
export var subText = "section-title-module--sub-text--1vwCO";